import { combineReducers } from 'redux';

import metricsGraphReducer from './metrics/metricsGraphSlice';
import dashboardGeneralSlice from './dashboardGeneralSlice';

export default combineReducers({
    metricsGraph: metricsGraphReducer,
    general: dashboardGeneralSlice,
});
